import {track} from 'managers/action-tracking.manager';

export const actionLoggerMiddleware = store => next => action => {
	let result = next(action);
	track(action);
	return result;
};
